import { DocumentAcknowledgement } from '@app/models/documents/document-acknowledgement.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';
import { Translatable } from '@app/types/translatable.type';
import { DocumentStatusDisplayOptions } from '@app/types/translatables/document-assign-display.options';
import { format } from 'date-fns';

export class AcknowledgementStatusColumn extends BadgeColumn<DocumentAcknowledgement> {
    title = 'document.status';
    property = 'acknowledgedAt';
    sortable = true;
    type: CellDisplay = CellDisplay.badge;

    getBadgeDisplay(doc: DocumentAcknowledgement): BadgeDisplay | undefined {
        if (doc.acknowledgedAt) {
            return;
        }

        return {
            type: 'warning',
            label: DocumentStatusDisplayOptions['notAcknowledged'],
        };
    }

    getCellText(documentAcknowledgement: DocumentAcknowledgement): Translatable | null {
        return documentAcknowledgement.acknowledgedAt
            ? {
                  key: 'document.acknowledgedOnDate',
                  params: {
                      date: format(documentAcknowledgement.acknowledgedAt, 'D MMM YYYY'),
                  },
              }
            : null;
    }
}
